import { type AccountResponse, AccountType } from '@shared/api';
import { AccountCardTile } from './card';
import { AccountPaymentTile } from './payment';

interface AccountTileBigProps {
  account: AccountResponse;
  mainAccount?: AccountResponse;
  subAccounts: AccountResponse[];
  selectedAccountId?: number;
  onAccountSwitch: (accountId: number) => void;
}

export const AccountTileBig = (props: AccountTileBigProps) => {
  if (props.account.type === AccountType.Payment)
    return (
      <AccountPaymentTile
        account={props.account}
        mainAccount={props.mainAccount}
        subAccounts={props.subAccounts}
        noHover
        selectedAccountId={props.selectedAccountId}
        onAccountSwitch={props.onAccountSwitch}
      />
    );
  else if (props.account.type === AccountType.Card) return <AccountCardTile account={props.account} noHover />;
  return null;
};
